import { createUploadLink } from 'apollo-upload-client'
import { setContext } from 'apollo-link-context'

import { getAuth } from '@/helpers/auth'

function getAccount() {
  if (typeof window !== 'undefined' && window.localStorage.getItem('loggedUser')) {
    var account = JSON.parse(window.localStorage.getItem('loggedUser')).id_account

    return account ?? ''
  }
}

const operations = [
  'ListProduct',
  'ListMeasure',
  'BrandsGlobal',
  'Brands',
  'ListCategory',
  'SubCategories',
  'CreateProduct',
  'UploadFile',
  'FindProductById',
  'UpdateProduct',
  'ListDepartment',
  'UploadProducts',
  'StoreProducts',
  'StoreProductById',
  'UpdateStoreProduct',
  'CreateStoreProduct',
  'FindProduct',
]

// Http endpoint
export const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'https://hulk-hotfix-beta.mercafacil.com/graphql'

export const getHttpLink = () => {
  const httpLink = createUploadLink({ uri: httpEndpoint })
  let fingerprint

  // Auth middleware
  const authLink = setContext((request, { headers = {} } = {}) => {
    // By spreading after the authorization key, if a query passes
    // a specific authorization header, it will overwrite the default header
    const localHeaders = {
      Authorization: getAuth(),
    }

    if (operations.includes(request.operationName)) {
      localHeaders.accountid = getAccount()
    }

    return {
      headers: {
        ...localHeaders,
        ...headers,
      },
    }
  })

  // Fingerprint middleware
  const fingerprintLink = setContext(async (request, { headers = {} } = {}) => {
    // Resolve the fingerprint only in the first request
    if (!fingerprint) {
      const fingerprintLocalStorage = JSON.parse(window.localStorage.getItem('fingerprint'))
      fingerprint = fingerprintLocalStorage?.visitorId
    }
    // By spreading after the fingerprint key, if a query passes
    // a specific fingerprint header, it will overwrite the default header
    return {
      headers: {
        fingerprint,
        ...headers,
      },
    }
  })

  return fingerprintLink.concat(authLink.concat(httpLink))
}
